<template lang="pug">
    div#map
        canvas#canvas(ref="canvas")
</template>

<script>
import { Deck, MapView } from '@deck.gl/core';
import { IconLayer } from '@deck.gl/layers';

import { EditableGeoJsonLayer, DrawRectangleMode, ViewMode } from 'nebula.gl';
import getBasemaps from './basemaps';
import center from '@turf/center';

import iconLocaiton from '../../imgs/icon-location.png';

const ICON_MAPPING = {
    marker: { x: 0, y: 0, width: 32, height: 32, mask: true },
};

let map;

export default {
    props: {
        location: Array,
        height: Number,
        drawing: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            collection: {
                type: 'FeatureCollection',
                features: [
                    /* insert features here */
                ],
            },
            longitude: 121.5,
            latitude: 31.232395363869415,
        };
    },
    created() {
        this.initGeojson();
    },
    watch: {
        collection() {
            this.$emit('aoiUpdated', this.collection);
        },
        height: {
            handler(height) {
                if (map) {
                    map.setProps({
                        height,
                    });
                } else {
                    setTimeout(() => {
                        map.setProps({
                            height,
                        });
                    }, 500);
                }
            },
            immediate: true,
        },
        location(v) {
            this.changeLocation(v);
        },
        drawing() {
            map.setProps({
                layers: this.getLayers(),
            });
        },
    },
    methods: {
        initGeojson() {
            // 尝试读取 sessionStorage 中存储的兴趣区的预设 geometry 字符串
            // 如果存在则设置为初始图形，并将地图定位到兴趣区所在范围附近
            // 例子：
            // {"type":"Polygon","coordinates":[[[121.763277942859,30.8656771906011],[121.777958968877,30.8656771906011],[121.777958968877,30.8824017527102],[121.763277942859,30.8824017527102],[121.763277942859,30.8656771906011]]]}

            const geometryGeojson =
                window.sessionStorage['aoi_geometry_geojson'];
            if (geometryGeojson) {
                try {
                    const feature = {
                        type: 'Feature',
                        geometry: JSON.parse(geometryGeojson),
                    };
                    this.collection = {
                        ...this.collection,
                        features: [feature],
                    };

                    const location = center(feature).geometry.coordinates;
                    this.longitude = location[0];
                    this.latitude = location[1];
                    this.changeLocation(location);
                } catch (e) {
                    console.log(e);
                }
                window.sessionStorage['aoi_geometry_geojson'] = '';
            }
        },
        changeLocation(v) {
            if (!map || !v || v.length < 2) {
                return;
            }
            const [longitude, latitude, _] = v;
            map.setProps({
                initialViewState: {
                    longitude,
                    latitude,
                    zoom: 10 + Math.random() * 3,
                    bearing: 0,
                    pitch: 0,
                },
                layers: this.getLayers(),
            });
        },
        getLayers() {
            const self = this;
            return [
                ...getBasemaps(),
                new EditableGeoJsonLayer({
                    id: 'geojson',
                    data: self.collection,
                    mode: this.drawing ? DrawRectangleMode : ViewMode,

                    selectedFeatureIndexes: [],

                    // Styles
                    filled: true,
                    pointRadiusMinPixels: 2,
                    pointRadiusScale: 2000,
                    extruded: true,
                    getElevation: 1000,
                    getFillColor: [200, 0, 80, 180],

                    // Interactive props
                    pickable: true,
                    autoHighlight: true,

                    onEdit: e => {
                        const { updatedData } = e;
                        const len = updatedData.features.length;
                        if (len > 1) {
                            updatedData.features = [updatedData.features.pop()];
                        }
                        self.collection = updatedData;
                        map.setProps({ layers: self.getLayers() });
                    },
                }),
                this.location &&
                    this.location.length >= 2 &&
                    new IconLayer({
                        id: 'icon-layer',
                        data: [{}],
                        pickable: true,
                        iconAtlas: iconLocaiton,
                        iconMapping: ICON_MAPPING,
                        getIcon: d => 'marker',
                        sizeScale: 5,
                        getPosition: d => [this.location[0], this.location[1]],
                        getSize: d => 5,
                        getColor: d => [255, 0, 0, 200],
                    }),
            ];
        },
    },
    mounted() {
        let h = this.height || 500;
        map = new Deck({
            canvas: this.$refs.canvas,
            width: '100%',
            height: h,
            initialViewState: {
                longitude: this.longitude,
                latitude: this.latitude,
                zoom: 13,
                minZoom: 1,
                maxZoom: 18,
            },
            controller: {
                // dragPan: false,
                // dragRotate: false,
                // doubleClickZoom: false,
            },
            getCursor: () => (this.drawing ? 'crosshair' : 'grab'),
            views: [
                new MapView({
                    id: 'map',
                    controller: true,
                    mapStyle:
                        'https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json',
                }),
            ],
            layers: this.getLayers(),
            // onClick(e) {
            //     console.log(e);
            // },
        });
    },
};
</script>

<style lang="stylus">
#canvas
    border-radius 10px
</style>
